const SourceIdVwr = {
  ADMIN: 'admin',
  LOCAL: 'local',
} as const;

export default SourceIdVwr;
